webpackJsonp([212839066777427],{

/***/ 210:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"], ["\n@media screen and (min-width: 40em) {\n   display: flex;\n   flex-wrap: wrap;\n   justify-content: space-between;\n   }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n    padding-bottom: 1rem;\n@media screen and (min-width: 40em) {\n   flex: 0 1 calc(50% - 1em);\n   min-width: 290px;\n   }\n   \n   @media screen and (min-width: 60em) {\n     flex: 0 1 calc(25% - 1em);\n}\n"], ["\n    padding-bottom: 1rem;\n@media screen and (min-width: 40em) {\n   flex: 0 1 calc(50% - 1em);\n   min-width: 290px;\n   }\n   \n   @media screen and (min-width: 60em) {\n     flex: 0 1 calc(25% - 1em);\n}\n"]),
	    _templateObject3 = _taggedTemplateLiteralLoose(["\n  color: black;\n"], ["\n  color: black;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _base = __webpack_require__(44);
	
	var _base2 = _interopRequireDefault(_base);
	
	var _header = __webpack_require__(46);
	
	var _header2 = _interopRequireDefault(_header);
	
	var _HeaderImage = __webpack_require__(28);
	
	var _HeaderImage2 = _interopRequireDefault(_HeaderImage);
	
	var _content = __webpack_require__(45);
	
	var _content2 = _interopRequireDefault(_content);
	
	var _TitleLayout = __webpack_require__(20);
	
	var _TitleLayout2 = _interopRequireDefault(_TitleLayout);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledDiv = _styledComponents2.default.div(_templateObject);
	
	var StyledCardContainer = _styledComponents2.default.div(_templateObject2);
	
	var StyledLink = _styledComponents2.default.a(_templateObject3);
	
	exports.default = function () {
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(
	      StyledDiv,
	      null,
	      _react2.default.createElement(
	        StyledCardContainer,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://8thlight.com/blog/georgina-mcfadyen/2017/05/01/elixir-umbrella-projects.html",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "blogs/umbrella.jpeg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                "Using an Elixir Umbrella"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledCardContainer,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          {
	            href: "https://8thlight.com/blog/georgina-mcfadyen/2017/03/27/working-efficiently-with-offshore-teams.html",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "blogs/overseas.jpg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                "Working Effectively with Offshore Teams "
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledCardContainer,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://8thlight.com/blog/georgina-mcfadyen/2017/01/19/common-code-smells.html",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "blogs/flowers.jpg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " Common Code Smells "
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledCardContainer,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          {
	            href: "https://8thlight.com/blog/georgina-mcfadyen/2016/09/28/good-craftsman-never-blames-his-tools.html",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "blogs/woodwork.jpg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " A Good Craftsman Never Blames His Tools"
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledCardContainer,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "https://8thlight.com/blog/georgina-mcfadyen/2016/06/27/inside-out-tdd-vs-outside-in.html",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "blogs/doors.jpg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                " TDD - From the Inside Out or the Outside In? "
	              )
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        StyledCardContainer,
	        null,
	        _react2.default.createElement(
	          StyledLink,
	          { href: "http://gemcfadyen.github.io/georginam.com/",
	            target: "_blank" },
	          _react2.default.createElement(
	            _base2.default,
	            { interactive: true },
	            _react2.default.createElement(
	              _header2.default,
	              null,
	              _react2.default.createElement(_HeaderImage2.default, { imageUrl: "blogs/books.jpg" })
	            ),
	            _react2.default.createElement(
	              _content2.default,
	              null,
	              _react2.default.createElement(
	                _TitleLayout2.default,
	                null,
	                "Apprenticeship Blog"
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 28:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n                background-image: url(", ");\n                background-size: cover;\n                background-position: center center;\n                width: 100%;\n                height: 180px;\n                border-top-left-radius: 12px;\n                border-top-right-radius: 12px;\n"], ["\n                background-image: url(", ");\n                background-size: cover;\n                background-position: center center;\n                width: 100%;\n                height: 180px;\n                border-top-left-radius: 12px;\n                border-top-right-radius: 12px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StyledImage = _styledComponents2.default.div(_templateObject, function (props) {
	                return "/" + props.imageUrl;
	});
	
	var HeaderImage = function HeaderImage(_ref) {
	                var imageUrl = _ref.imageUrl,
	                    children = _ref.children;
	                return _react2.default.createElement(
	                                StyledImage,
	                                { imageUrl: imageUrl },
	                                " ",
	                                children,
	                                " "
	                );
	};
	
	exports.default = HeaderImage;
	module.exports = exports["default"];

/***/ }),

/***/ 20:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center;\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  width: 100%;\n  justify-content: center;\n  vertical-align: middle;\n  font-weight: bold;\n  text-align: center;\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n padding: 8px;\n"], ["\n padding: 8px;\n"]);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _styledComponents = __webpack_require__(7);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var TitleLayout = _styledComponents2.default.div(_templateObject);
	var Layout = _styledComponents2.default.div(_templateObject2);
	var TitleContent = function TitleContent(_ref) {
	  var children = _ref.children;
	  return _react2.default.createElement(
	    Layout,
	    null,
	    _react2.default.createElement(
	      TitleLayout,
	      null,
	      children
	    )
	  );
	};
	
	exports.default = TitleContent;
	module.exports = exports["default"];

/***/ }),

/***/ 217:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	exports.default = Index;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _container = __webpack_require__(23);
	
	var _container2 = _interopRequireDefault(_container);
	
	var _BlogCards = __webpack_require__(210);
	
	var _BlogCards2 = _interopRequireDefault(_BlogCards);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function Index(_ref) {
	  var data = _ref.data;
	  var posts = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    _container2.default,
	    null,
	    _react2.default.createElement(_BlogCards2.default, null)
	  );
	}
	
	var pageQuery = exports.pageQuery = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-blog-js-f9dec7bd556a66ace3ef.js